import PropTypes from "prop-types";

export const applePayButtonPropType = PropTypes.shape({
  type: PropTypes.string,
  style: PropTypes.string,
});
